
import Vue from "vue"
import {Prop} from "vue-property-decorator"
import Component from "vue-class-component"
import {QItemSection} from "quasar"

@Component({components: {QItemSection}})
export default class MenuItem extends Vue {
  @Prop()
  icon: string

  @Prop()
  name: string

  @Prop()
  path: string

  @Prop()
  to: string

  @Prop()
  active: string

  @Prop()
  sub: boolean

  @Prop({default: false})
  subItem: boolean

  get activeClassName() {
    return this.active === this.name || (!this.sub && this.$route.path.startsWith(this.path))
      ? "active"
      : ""
  }
}
